// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3EJRc","image":"Header_image__3eAwp","name":"Header_name__1-v7R","info":"Header_info__3uIks","infoRow":"Header_infoRow__gjl7z"};